import React, { useEffect } from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";

type Props = {};

export const ChangeToOrder = (props: Props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams<{ guid: string }>();

    useEffect(() => {
        const guid = params.guid;
        if (guid) {
            let type = "orders";

            if (location.pathname.indexOf("quotes") > -1) {
                type = "quotes";
            }

            navigate(`/${type}/${guid}/entry`);
        }
    }, []);

    return <div className={"ChangeToOrder"}></div>;
};
